/**
 * Rating label constants for the review system
 */

export const RATING_LABELS: Record<number, string> = {
  1: 'Poor',
  2: 'Fair',
  3: 'Good',
  4: 'Amazing',
  5: 'Excellent',
};

export const getRatingLabel = (rating: number): string => {
  const roundedRating = Math.round(rating);
  return RATING_LABELS[roundedRating] || '';
};

export const getRatingColor = (rating: number): string => {
  if (rating >= 4.5) return 'text-green-600';
  if (rating >= 3.5) return 'text-yellow-600';
  if (rating >= 2.5) return 'text-orange-500';
  return 'text-red-500';
};

export const getRatingBgColor = (rating: number): string => {
  if (rating >= 4.5) return 'bg-green-50';
  if (rating >= 3.5) return 'bg-yellow-50';
  if (rating >= 2.5) return 'bg-orange-50';
  return 'bg-red-50';
};
